<template>
  <div class="page">
    <div class="header">
      <van-tabs @click="onClick" color="#2A70F2" title-active-color="#2A70F2">
        <van-tab title="证书查询">
          <div class="group_1">
            <div class="box_1">
              <van-form>
                <van-field
                  v-model="formData.gender"
                  label="查询方式"
                  placeholder="请选择查询方式"
                  input-align="right"
                  readonly
                  right-icon="arrow"
                  @click="showPicker = true"
                  error-message-align="right"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker show-toolbar :columns="genderColumns" @confirm="onGenderConfirm" @cancel="showPicker = false" />
                </van-popup>
                <van-field
                  v-if="formData.gender === '身份信息'"
                  v-model="username"
                  name="姓名"
                  label="姓名"
                  placeholder="请输入姓名"
                  error-message-align="right"
                  input-align="right"
                />
                <van-field
                  v-if="formData.gender === '身份信息'"
                  v-model="idCard"
                  name="身份证"
                  label="身份证"
                  placeholder="请输入身份证号码"
                  input-align="right"
                  error-message-align="right"
                />
                <van-field
                  v-if="formData.gender === '证书编号'"
                  v-model="certificateNumber"
                  name="证书编号"
                  label="证书编号"
                  placeholder="请输入证书编号"
                  input-align="right"
                  error-message-align="right"
                />
                <div style="display: flex; align-items: center">
                  <van-field
                    v-model="codeValue"
                    name="验证码"
                    label="验证码"
                    placeholder="请输入验证码"
                    input-align="right"
                    error-message-align="right"
                  />
                  <img
                    :src="'data:image/png;base64,' + codeImg"
                    alt=""
                    style="width: 100px; height: 50px; margin-left: 10px; cursor: pointer"
                    @click="getImgCode"
                  />
                </div>
              </van-form>
            </div>
            <div style="margin-top: 24px; display: flex; align-items: center; justify-content: center">
              <van-button round block type="info" @click="onSubmit">立即查询</van-button>
            </div>
          </div>
        </van-tab>
        <van-tab title="学时查询">
          <div class="group_1">
            <div class="box_2">
              <van-form>
                <van-field
                  v-model="username"
                  name="姓名"
                  label="姓名"
                  placeholder="请输入姓名"
                  error-message-align="right"
                  input-align="right"
                />
                <van-field
                  v-model="idCard"
                  name="身份证"
                  label="身份证"
                  placeholder="请输入身份证号码"
                  input-align="right"
                  error-message-align="right"
                />
                <div style="display: flex; align-items: center">
                  <van-field
                    v-model="codeValue"
                    name="验证码"
                    label="验证码"
                    placeholder="请输入验证码"
                    input-align="right"
                    error-message-align="right"
                  />
                  <img
                    :src="'data:image/png;base64,' + codeImg"
                    alt=""
                    style="width: 100px; height: 50px; margin-left: 10px; cursor: pointer"
                    @click="getImgCode"
                  />
                </div>
                <div style="margin: 24px; display: flex; align-items: center; justify-content: center">
                  <van-button round block type="info" @click="onSubmit1">立即查询</van-button>
                </div>
              </van-form>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { doCertVerify, doCreditVerify } from '../../api/zscy';
import { captchaImage } from '@/api/login.js';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    return {
      showPicker: false,
      formData: {
        gender: '身份信息'
      },
      username: '',
      idCard: '',
      certificateNumber: '',
      codeImg: '',
      uuid: '',
      genderColumns: ['身份信息', '证书编号'],
      codeValue: '',
      uuid: '',
      trainCertList: ''
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    onGenderConfirm(value) {
      this.formData.gender = value;
      this.showPicker = false;
      this.codeValue = '';
    },
    onClick() {
      this.getImgCode();
      this.username = '';
      this.idCard = '';
      this.certificateNumber = '';
      this.codeValue = '';
    },
    //图片验证码
    getImgCode() {
      captchaImage().then(res => {
        this.codeImg = res.data.img;
        this.uuid = res.data.uuid;
        this.codeValue = '';
      });
    },
    //证书查询
    onSubmit() {
      const { gender } = this.formData;
      if (gender === '身份信息') {
        // 按照身份信息查询时：校验姓名、身份证
        if (!this.username || this.username.trim() === '') {
          this.$utils.showToast('请输入姓名！');
          return;
        }
        if (!this.idCard || this.idCard.trim() === '') {
          this.$utils.showToast('请输入身份证号！');
          return;
        }
      } else if (gender === '证书编号') {
        // 按照证书编号查询时：校验证书编号
        if (!this.certificateNumber || this.certificateNumber.trim() === '') {
          this.$utils.showToast('请输入证书编号！');
          return;
        }
      }
      if (!this.codeValue || this.codeValue.trim() === '') {
        this.$utils.showToast('请输入验证码！');
        return;
      }
      const params = {
        searchType: gender === '身份信息' ? '01' : '02',
        cardno: this.idCard,
        certNo: this.certificateNumber,
        valideCode: this.codeValue,
        realname: this.username,
        uuid: this.uuid
      };

      doCertVerify(params).then(res => {
        this.trainCertList = res.data.data.trainCertList;
          this.$store.commit('m_user/updateTrainCertList', this.trainCertList);
        if (res.data.data.result == '1') {
          this.$router.push({
            path: '/list',
          });
        } else if (res.data.data.result == '2') {
          this.$utils.showToast(res.data.data.msg);
        } else if (res.data.data.result == '3') {
          this.$utils.showToast(res.data.data.msg);
        }
      });
    },
    //按学时查询
    onSubmit1() {
      if (!this.username || this.username.trim() === '') {
        this.$utils.showToast('请输入姓名！');
        return;
      }
      if (!this.idCard || this.idCard.trim() === '') {
        this.$utils.showToast('请输入身份证号！');
        return;
      }
      if (!this.codeValue || this.codeValue.trim() === '') {
        this.$utils.showToast('请输入验证码！');
        return;
      }
      const params = {
        cardNo: this.idCard,
        valideCode: this.codeValue,
        realName: this.username,
        uuid: this.uuid
      };

      doCreditVerify(params).then(res => {
          this.$store.commit('m_user/updateStudyList',  res.data.data.list);
        if (res.data.data.result == '1') {
          this.$router.push({
            path: '/studyList',
          });
        } else if (res.data.data.result == '2') {
          this.$utils.showToast(res.data.data.msg);
        } else if (res.data.data.result == '3') {
          this.$utils.showToast(res.data.data.msg);
        }
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getImgCode();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.page {
  background-color: #f6f8fa;
  height: 100vh;
  overflow-y: scroll;
}
.group_1 {
  padding: 10px 15px;
}
.box_1 {
  // width: 345px;

  padding: 0 15px 16px 15px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
}
.title {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid#f5f6f7;
  font-size: 14px;
  color: #646566;
  height: 40px;
  .text_1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 15px;
  }
}
::v-deep {
  .van-button {
    width: 180px;
    height: 46px;
    background: #2a70f2;
    border-radius: 8px 8px 8px 8px;
  }
}
.box_2 {
  // width: 345px;
  padding: 0 15px 16px 15px;
  height: 184px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
}
::v-deep {
  .van-cell-group--inset {
    margin: 0;
    border-top: 0;
  }
  .van-cell-group--inset::after {
    border: 0;
  }
  .van-cell {
    padding: 0;
    display: flex;
    align-items: center;
    height: 56px;
  }
  .van-cell::after {
    border-bottom: 1px solid #ebedf0;
    // width: 315px;
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .van-icon {
    color: #969799;
  }

  .van-cell:nth-child(4)::after {
    // border-bottom: 0 !important;
  }
}
</style>
